// apps/api/src/qxcircle/qxcircle-comment-notification.ts
// Description: Local comment/reply notification payloads (Slice 18–23).
// Owner: Masa Bayu
// Date: 2026-08-24

import type { QxCircleNotification } from "./qxcircle.types";

export function createCommentNotification(
  seq: number,
  authorName: string,
  postId: string,
): QxCircleNotification {
  return {
    id: `qxcircle_ntf_comment_${seq}`,
    kind: "comment",
    title: `Commented on ${authorName}'s post`,
    body: "Local notification simulated — not production push.",
    href: `/qxcircle/post/${encodeURIComponent(postId)}`,
    read: false,
    createdAt: new Date().toISOString(),
  };
}

export function createReplyNotification(
  seq: number,
  authorName: string,
  postId: string,
): QxCircleNotification {
  return {
    id: `qxcircle_ntf_reply_${seq}`,
    kind: "reply",
    title: `Replied to ${authorName}'s comment`,
    body: "Local notification simulated — not production push.",
    href: `/qxcircle/post/${encodeURIComponent(postId)}`,
    read: false,
    createdAt: new Date().toISOString(),
  };
}
